import { type ShowCountFormatter } from 'rc-input/lib/interface'

export const cleanInput = (value: string): string => {
  let result = ''
  for (const char of value) {
    if (char === ' ') {
      if (!result.endsWith(' ') && result.length) {
        result += char
      }
    } else if (char === '\n') {
      if (!result.endsWith('\n\n') && result.length) {
        result += char
      }
    } else {
      result += char
    }
  }
  return result
}

export const cleanValueTail = (value: string): string => {
  let result = value.replace(/^[ \t]+|[ \t]+$/g, '')
  result = result.replace(/\n{3,}/g, '\n\n')
  result = result.replace(/[ \t]+\n/g, '\n')
  result = result.replace(/\n[ \t]+/g, '\n')
  return result
}

export const handlePaste = (
  e: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  stringValue: string,
  maxLength: number | undefined,
  blockClipboard: boolean,
  onChange: (value: string) => void,
) => {
  e.preventDefault()
  const pastedText = e.clipboardData.getData('text/plain')
  const normalizedPastedText = cleanInput(pastedText)

  const target = e.target as HTMLInputElement | HTMLTextAreaElement
  const start = target.selectionStart ?? 0
  const end = target.selectionEnd ?? 0
  const newValue = cleanInput(
    stringValue.slice(0, start) + normalizedPastedText + stringValue.slice(end),
  )
  const finalValue =
    (maxLength && newValue.length <= maxLength) || !maxLength || !blockClipboard
      ? newValue
      : stringValue

  onChange(finalValue)

  setTimeout(() => {
    target.selectionStart = target.selectionEnd =
      start + normalizedPastedText.length
  }, 0)
}

export const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  onChange: (value: string) => void,
) => {
  const newValue = e.target.value
  onChange(newValue)
}

export const handleKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  stringValue: string,
) => {
  const target = e.target as HTMLInputElement | HTMLTextAreaElement
  const { selectionStart, selectionEnd } = target
  if (!selectionStart || !selectionEnd) return
  const textBefore = stringValue.slice(0, selectionStart)
  const textAfter = stringValue.slice(selectionEnd)

  if (e.key === ' ') {
    if (
      !textBefore.length ||
      textBefore.endsWith(' ') ||
      textAfter.startsWith(' ')
    ) {
      e.preventDefault()
      return
    }
  } else if (e.key === 'Enter') {
    if (
      !textBefore.length ||
      textBefore.endsWith('\n\n') ||
      textAfter.startsWith('\n\n')
    ) {
      e.preventDefault()
      return
    }
  }
}

export const createCustomShowCountFormatter = (
  maxLength?: number,
  errorColor: string = 'red',
): { formatter: ShowCountFormatter } => ({
  formatter: ({ count, maxLength: formatterMaxLength }) => {
    const isError = maxLength !== undefined && count > maxLength
    return (
      <div style={{ color: isError ? errorColor : '' }}>
        {count} / {maxLength ?? formatterMaxLength ?? '-'}
      </div>
    )
  },
})

export const handleBlur = (
  stringValue: string,
  onChange: (value: string) => void,
) => {
  const cleanedValue = cleanValueTail(stringValue)
  onChange(cleanedValue)
}
